import React from 'react';
import PropTypes from 'prop-types';
import { Header, SummaryWithoutLogoTotal, SmartTitle, ColumnTitle, Line, mandates } from './styles';
import colors from '../../colors';
import { percentFormat } from '../../Utils/NumberFormatting';
import { Button } from '../InterestingDistricts/styles';
import styled, { css } from 'react-emotion';
import { ArrowRight } from '../Button/styles'

const PartyColumn = styled.div`
	width: 100%;
	margin-bottom: 0.5rem;

	@media (max-width: 759px) {
		display: none;
	}
`

const Summary = styled(SummaryWithoutLogoTotal)`
	@media (max-width: 760px) {
		display: none;
	}
`

const LineWrap = styled.div`
	flex: 1 0 auto;
	width: 100%;

	@media (min-width: 480px) {
		display: inline-block;
		vertical-align: middle;
	}
`

const summaryButton = css`
	margin: 0 0 1rem;
	cursor: pointer;

	@media (min-width: 760px) {
		display: none;
	}
	
	@media (max-width: 480px) {
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
`;

const WidgetDiagram = styled.div`
	float: left;
	width: 58%;
	
	@media (min-width: 1023px) {
		width: 68%;
	}
`

const PoliticalPartiesButton = styled.div`
	display: none;
	a {
		padding: 0 2rem 0 1rem;
		font-size: 0.875rem;
	}
	@media (min-width: 760px) {
		position: absolute;
		bottom: 16px;
		right: 10px;
		display: block;
		float: right;
		max-width: 150px;
		width: calc(100% - 58% - 2rem);
	}
	@media (min-width: 1023px) {
		width: calc(100% - 68% - 2rem);
	}
`

export default class WidgetSummaryDiagram extends React.PureComponent {
	onClick = (id) => {
		window.top.location.href = `${this.props.link}#/obvod/${id}`;
	}

	render() {
		const max = this.props.parties[0] ? this.props.parties[0].count : 0;
		return <>
			<Header>
				<SmartTitle>Senátní volby - Výsledky ve 2. kole</SmartTitle>
				<Summary className={mandates}>Počet mandátů:</Summary>
				<SummaryWithoutLogoTotal>
					Volební účast: {percentFormat(this.props.meta.turnout, 2)}
				</SummaryWithoutLogoTotal>
				<SummaryWithoutLogoTotal>
					Sečteno: {percentFormat(this.props.meta.count, 2)}
				</SummaryWithoutLogoTotal>
				<Button className={summaryButton} reverse href={this.props.link}>
					Přehled všech obvodů
				</Button>
			</Header>
			<WidgetDiagram>
				{this.props.parties.map((party, index) => {
					const relative = max ? party.count / max * 100 : 0;
					return <PartyColumn key={index}>
						<ColumnTitle title={party.shortcut}>{party.shortcut}</ColumnTitle>
						<LineWrap>
							<Line
								style={{
									backgroundColor: colors[party.id] || colors.default,
									width: relative +'%'
								}}
							>
								{party.count}
							</Line>
						</LineWrap>
					</PartyColumn>;
				})}
			</WidgetDiagram>
			<PoliticalPartiesButton>
				<Button reverse href={this.props.link}>
					<ArrowRight>Všechny strany</ArrowRight>
				</Button>
			</PoliticalPartiesButton>
		</>;
	}
}

WidgetSummaryDiagram.propTypes = {
	meta: PropTypes.shape({
		turnout: PropTypes.number.isRequired
	}).isRequired,
	link: PropTypes.string.isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	leaders: PropTypes.object.isRequired,
	logos: PropTypes.object
}

WidgetSummaryDiagram.defaultProps = {
	logos: {}
}
